import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService, ResponseObject } from './auth.service';
import { ServiceBase } from './service.base';
import { SaveSubscriptionRulesRequest, SubscriptionRules, SubscriptionRuleSetUsers } from '../models/subscriptionrules.model';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionRulesService extends ServiceBase {
  private api: string = '/subscriptionRules';

  constructor(private http: HttpClient,
    authService: AuthService) {
    super(authService);
  }

  public canAddNewProduct(artistId: string): Observable<boolean> {
    var httpOptions = this.RequestHeaders();

    const method: string = '/' + artistId + '/can-add-products';
    var url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<boolean>(url, httpOptions);
  }

  public canSendMoreInvites(): Observable<boolean> {
    var httpOptions = this.RequestHeaders();

    const method: string = '/can-send-invites';
    var url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<boolean>(url, httpOptions);
  }

  public CanAcceptMoreConsignmentProducts(): Observable<{ IsHaveLimit: boolean, Limit: number }> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/can-accept-products'; // Replace with your API endpoint
    const url: string = `${environment.BASE_API_PATH}${this.api}${method}`;
    return this.http.get<{ IsHaveLimit: boolean, Limit: number }>(url, httpOptions);
  }
 




  public getSubscriptionRules(): Observable<SubscriptionRules[]> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/SupscriptionRuleSet';
    const method: string = '/fetchSubscriptionRuleSets';
    var url: string = environment.BASE_API_PATH + api + method;
    return this.http.get<SubscriptionRules[]>(url, httpOptions);
  }

  public getActiveSubscriptionRules(): Observable<SaveSubscriptionRulesRequest> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/SupscriptionRuleSet';
    const method: string = '/fetchActiveSubscriptionRuleSet';
    var url: string = environment.BASE_API_PATH + api + method;
    return this.http.get<SaveSubscriptionRulesRequest>(url, httpOptions);
  }

  public saveSubscriptionRules(createSubciption: SaveSubscriptionRulesRequest): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/SupscriptionRuleSet';
    const method: string = '/saveSubscriptionRuleSet';
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.post<ResponseObject>(url, createSubciption, httpOptions);
  }

  public switchSubscriptionRules(ruleSetId: string): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/SupscriptionRuleSet';
    const method: string = '/SwitchSubscriptionRuleSet/' + ruleSetId;
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.post<ResponseObject>(url, {}, httpOptions);
  }

  public CanGenrateDescriptionWithAi(): Observable<boolean> {
    var httpOptions = this.RequestHeaders();

    const method: string = '/can-generateDescription-with-AI';
    var url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<boolean>(url, httpOptions);
  }

  public fetchRemaningAiCalls(): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();

    const method: string = '/fetch-remaing-AI-calls';
    var url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ResponseObject>(url, httpOptions);
  }

  public fetchRuleSetsDropdown(): Observable<SelectItem[]> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/SupscriptionRuleSet';
    const method: string = '/fetch-ruleSet-dropdown';
    var url: string = environment.BASE_API_PATH + api + method;
    return this.http.get<SelectItem[]>(url, httpOptions);
  }

  public fetchAllSubscriptionRuleSetUsers(subscriptionRuleSetId: string): Observable<SubscriptionRuleSetUsers[]> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/SupscriptionRuleSet';
    const method: string = '/fetch-allUsers-of-SubscriptionRuleSet/' + subscriptionRuleSetId;
    var url: string = environment.BASE_API_PATH + api + method;
    return this.http.get<SubscriptionRuleSetUsers[]>(url, httpOptions);
  }

  public generatePortfolio(): Observable<boolean> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/SubscriptionRules';
    const method: string = '/can-generate-portfolio';
    var url: string = environment.BASE_API_PATH + api + method;
    return this.http.get<boolean>(url, httpOptions);
  }

}